import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router";
import { useAuth } from "../context/AuthContext";
import { ACCOUNT_NAV_ITEMS, TOOL_NAV_ITEMS } from "../constants/navigation";
import "./HamburgerMenu.css";

function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const { user, logout } = useAuth();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      // Prevent body scroll when menu is open
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // Close menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <div className="hamburger-menu-container" ref={menuRef}>
      <button
        className={`hamburger-button ${isOpen ? "open" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isOpen}
        aria-controls="hamburger-menu"
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      {isOpen && (
        <>
          <div
            className="hamburger-overlay"
            onClick={closeMenu}
            aria-hidden="true"
          />
          <nav
            id="hamburger-menu"
            className="hamburger-menu"
            role="navigation"
            aria-label="Main navigation menu"
          >
            <div className="hamburger-menu-header">
              <span className="hamburger-user-info">
                {user?.displayName || user?.email}
              </span>
              <button
                className={`hamburger-button ${isOpen ? "open" : ""}`}
                onClick={toggleMenu}
                aria-label="Toggle navigation menu"
                aria-expanded={isOpen}
                aria-controls="hamburger-menu"
              >
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </button>
            </div>
            <ul className="hamburger-menu-list">
              {[...TOOL_NAV_ITEMS, ...ACCOUNT_NAV_ITEMS].map(({ id, to, label }) => (
                <li key={id}>
                  <Link
                    to={to}
                    className="hamburger-menu-item"
                    onClick={closeMenu}
                  >
                    {label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="hamburger-menu-item"
                  onClick={closeMenu}
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/newsletter"
                  className="hamburger-menu-item"
                  onClick={closeMenu}
                >
                  Newsletter
                </Link>
              </li>
              <li>
                <a
                  href="mailto:contact.tekra@gmail.com"
                  className="hamburger-menu-item"
                  onClick={closeMenu}
                  aria-label="Contact us via email"
                >
                  Contact
                </a>
              </li>
              <li>
                <button
                  onClick={handleLogout}
                  className="hamburger-menu-item hamburger-menu-button"
                >
                  Logout
                </button>
              </li>
            </ul>
          </nav>
        </>
      )}
    </div>
  );
}

export default HamburgerMenu;
